import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { MenuList, MenuItem } from '@material-tailwind/react';
import EventNameCard from './EventNameCard';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}
const DropDownMenuCard = ({ data, currentUrl }) => {
  const [currentItemData, setCurrentItemData] = useState(null);
  const [activeLink, setActiveLink] = useState(false);

  const handleListData = (obj) => {
    if (obj) {
      localStorage.setItem('objList', JSON.stringify(obj));
      setCurrentItemData(obj);
      if (currentUrl.toLowerCase() === obj?.default.toLowerCase()) {
        setActiveLink(true);
      }
    }
  };
  useEffect(() => {
    if (localStorage.getItem('objList')) {
      setCurrentItemData(JSON.parse(localStorage.getItem('objList')));
      if (activeLink) {
        setActiveLink(true);
      }
    }
  }, []);

  return (
    <MenuList className='p-0 menusList shadow-none outline-none border-none rounded-xl max-w-7xl mx-auto p'>
      <div className='dropDownGrid justify-items-start overflow-hidden max-w-2xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4'>
        <div className='pt-4 px-4'>
          <NavLink
            to={data?.url}
            onClick={() => localStorage.removeItem('objList')}>
            <h3 className='font-semibold capitalize text-xl pl-2 text-black'>
              {data?.label}
            </h3>
          </NavLink>
          <hr className='relative -left-5 w-28 h-1 mb-2 bg-eventLightYellow' />
          {data?.children?.map((list) => (
            <MenuItem
              key={`submenusList${list?.id}`}
              className='capitalize pb-1 text-eventGray text-base tracking-wider hover:text-eventYellow hover:bg-transparent font-medium'>
              <div
                type='button'
                onClick={() => handleListData(list)}
                className={classNames(
                  currentUrl?.includes(
                    `/${list?.url?.slice(1).toLowerCase()}`
                  ) || activeLink
                    ? 'text-eventLightYellow'
                    : 'text-eventGray',
                  'activeLink flex items-center group text-eventGray hover:text-eventLightYellow'
                )}>
                <span
                  className={classNames(
                    currentUrl?.includes(
                      `/${list?.url?.slice(1).toLowerCase()}`
                    )
                      ? 'bg-eventPink'
                      : 'bg-eventLightGray',
                    'w-10 h-10 mr-3 rounded-full flex items-center justify-center'
                  )}>
                  {list?.icon}
                </span>
                {list?.label}
              </div>
            </MenuItem>
          ))}
        </div>
        <EventNameCard defaultImg={data?.defaultImg} data={currentItemData} />
      </div>
    </MenuList>
  );
};

export default DropDownMenuCard;
